import React, { useState } from "react";
import { CBadge, CCol, CContainer, CForm, CRow } from "@coreui/react";
import "./QuizComponent.css";

function TrueFalse({
  type,
  num,
  question,
  score,
  data = [],
  onAnswerChange,
  questionID,
  questionTypeID,
  isCorrect,
  isQuestionsFetched,
  currentPage
}) {
  const [selectedOption, setSelectedOption] = useState(null);

  // Function to handle the selection of an answer
  const handleSelectAnswer = (optionId) => {
    setSelectedOption(optionId);
    onAnswerChange(questionID, questionTypeID, optionId);
  };

  // Function to determine the checkmark/cross icon based on the correctness of the answer
  const getIcon = (option) => {
    if (isCorrect === 1 && option.userAnswer) {
      return <span style={{ color: "#28a745", marginLeft: "5px" }}>✔️</span>;
    }
    if (isCorrect === 0 && option.correctAnswer) {
      return <span style={{ color: "#dc3545", marginLeft: "5px" }}>✔️</span>;
    }
    if (isCorrect === 0 && option.userAnswer) {
      return <span style={{ color: "#dc3545", marginLeft: "5px" }}>❌</span>;
    }
    return null;
  };

  // Determine if the inputs should be disabled based on the type (for review mode)
  const isDisabled = type === "review";

  return (
    <CContainer className="mb-3 questionContainer">
      <ol>
        <CRow className="justify-content-between">
          <CCol>
            <div>
                <span>
                  <span style={{fontWeight: '650'}}>{`Q${isQuestionsFetched ? currentPage : num + 1})`}</span>{' '}
                  <span style={{fontWeight: '650'}}>
                    {question}
                  </span>
                </span>
              <CForm>
                <ul>
                  <CRow xs={{ gutterY: 2 }}>
                    {data &&
                      data.map((option) => (
                        <CCol xs={6} lg={5} key={option.optionId}>
                          <div className="d-flex">
                            <input
                              disabled={isDisabled}
                              className={`form-check-input options`}
                              type="radio"
                              name={`question-${questionID}`} // Ensure unique name per question
                              id={option.optionId}
                              value={option.optionValue}
                              onChange={() => handleSelectAnswer(option.optionId)}
                              checked={selectedOption === option.optionId}
                            />
                            <label
                              className="optionText"
                              style={{ marginLeft: "4px" }}
                              htmlFor={option.optionId}
                            >
                              {option.optionValue}
                            </label>
                            {getIcon(option)} {/* Show the checkmark or cross */}
                          </div>
                        </CCol>
                      ))}
                  </CRow>
                </ul>
              </CForm>
            </div>
          </CCol>
          <CCol className="align-self-start" xs={2} md={1}>
            <div className="text-center">
              <h2>
                <CBadge title="Score per question" shape="rounded-pill" color="primary">
                  {score}
                </CBadge>
              </h2>
            </div>
          </CCol>
        </CRow>
      </ol>
    </CContainer>
  );
}

export default TrueFalse;
